import React from 'react';
import { Link } from 'react-router-dom';
import { FinancialValue } from '@/components/shared/FinancialValue';

interface DemoReportCardProps {
  report: {
    id: string;
    client_name: string;
    claimant_name: string;
    status: string;
    created_at: string;
    pdf_url?: string;
    result?: {
      final_claim_amount?: number;
    };
  };
}

export default function DemoReportCard({ report }: DemoReportCardProps) {
  const getStatusColor = (status: string): React.CSSProperties => {
    switch (status) {
      case 'completed':
        return { backgroundColor: 'transparent', color: 'var(--color-verified)' };
      case 'processing':
        return { backgroundColor: 'var(--color-needs-human-tint)', color: 'var(--color-needs-human-text)' };
      case 'causation_failed':
        return { backgroundColor: 'var(--color-needs-human-tint)', color: 'var(--color-needs-human-text)' };
      case 'failed':
        return { backgroundColor: 'var(--color-needs-human-tint)', color: 'var(--color-needs-human-text)' };
      default:
        return { backgroundColor: 'var(--color-bg-elevated)', color: 'var(--color-text-primary)' };
    }
  };

  return (
    <div className="border rounded-lg hover:shadow-lg transition-shadow" style={{ borderColor: 'var(--color-border)' }}>
      <Link to={`/demo-report/${report.id}`} className="block p-4">
        <div className="flex justify-between items-start mb-3">
          <div className="flex-1">
            <h3 className="font-semibold text-lg transition-colors" style={{ color: 'var(--color-text-primary)' }}>
              {report.client_name}
            </h3>
            <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>Claimant: {report.claimant_name}</p>
            <p className="text-xs mt-1" style={{ color: 'var(--color-text-muted)' }}>
              Generated: {new Date(report.created_at).toLocaleDateString()}
            </p>
          </div>
          <div className="text-right ml-4">
            <p className="text-2xl font-bold" style={{ color: 'var(--color-needs-human-text)' }}>
              {report.result?.final_claim_amount
                ? <FinancialValue value={report.result.final_claim_amount} />
                : report.status === 'causation_failed'
                ? 'Review Needed'
                : report.status === 'processing'
                ? 'Calculating...'
                : 'Completed'}
            </p>
            <span
              className="inline-block px-3 py-1 rounded-full text-xs font-semibold mt-2"
              style={
                report.status === 'causation_failed'
                  ? { backgroundColor: 'var(--color-needs-human-tint)', color: 'var(--color-needs-human-text)' }
                  : getStatusColor(report.status)
              }
            >
              {report.status === 'causation_failed' ? 'Causation Test Failed' : report.status}
            </span>
          </div>
        </div>
      </Link>

      <div className="border-t px-4 py-3" style={{ backgroundColor: 'var(--color-bg-base)' }}>
        <p className="text-xs italic" style={{ color: 'var(--color-text-muted)' }}>
          Click to view detailed report breakdown
        </p>
      </div>
    </div>
  );
}
